import DataGrid from 'components/DataGrid/DataGrid';
import moment from 'moment';
import { Trans, useTranslation } from 'react-i18next';
import { trimEmptyStringsFromQuery } from 'helpers/helpers';
import makeStyles from '@material-ui/styles/makeStyles';

const dateFormat = 'YYYY-MM-DD';

import columnConfig from './columnConfig';

const useStyles = makeStyles(() => ({
  description: {
    marginTop: '-12px',
    marginBottom: '18px',
  },
}));

const EcommerceBagHistory = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <div className={classes.description}>
        <Trans
          i18nKey="ecommerceBags.history.description"
          components={{ b: <b /> }}
          values={{
            dateFrom: moment().subtract(1, 'years').format('DD.MM.YYYY'),
            dateTo: moment().subtract(1, 'days').format('DD.MM.YYYY'),
          }}
        />
      </div>
      <DataGrid
        remove={true}
        export={true}
        noRefresh={true}
        paginationTop={true}
        paginationBottom={false}
        url="/ecommerce-bags-view"
        reportName="viewbag"
        columns={columnConfig(t)}
        role="BAG"
        minRows={20}
        defaultHiddenColumns={[
          'orderId',
          'isSubscription',
          'hasAddons',
          'city',
          'zoneName',
          'clientDietName',
          'clientVariantName',
          'clientCalorificName',
          'clientOptionChangeMenu',
          'clientUseEcoContainers',
        ]}
        defaultFiltered={[
          {
            id: 'date',
            value: {
              after: moment().subtract(1, 'years').format(dateFormat),
              before: moment().subtract(1, 'days').format(dateFormat),
            },
          },
          {
            id: 'active',
            value: true,
          },
          {
            id: 'systemStatus',
            value: 'PAID',
          },
        ]}
        manipulateQuery={(requestData, query) => {
          // eslint-disable-next-line no-underscore-dangle
          query._orX = [];

          if (query.user) {
            // eslint-disable-next-line no-underscore-dangle
            query._orX.push([
              {
                clientFirstName: query.user.split(' '),
                clientLastName: query.user.split(' '),
              },
            ]);
            delete query.user;
          }

          if (query.date) {
            const { after, before } = query.date;
            if (after) {
              query['date[after]'] = after;
            }

            if (before) {
              query['date[before]'] = before;
            }

            delete query.date;
          }

          if (query.deliveredAt) {
            const { after, before } = query.deliveredAt;
            if (after) {
              query['deliveredAt[after]'] = after;
            }

            if (before) {
              query['deliveredAt[before]'] = before;
            }

            delete query.deliveredAt;
          }

          if (query.address) {
            const search = query.address;
            delete query.address;
            let splicedSearch = search.split(' ');
            splicedSearch = trimEmptyStringsFromQuery(splicedSearch);

            // eslint-disable-next-line no-underscore-dangle
            query._orX.push([
              {
                city: splicedSearch,
                street: splicedSearch,
                postCode: splicedSearch,
                buildNumber: splicedSearch,
                placeNumber: splicedSearch,
                pickUpPoint: splicedSearch,
              },
            ]);

            delete query.address;
          }

          if (query.realFoodCost) {
            const filters = query.realFoodCost;
            delete query.realFoodCost;
            if (filters.valueFrom) {
              query['realFoodCost[gte]'] = filters.valueFrom;
            }
            if (filters.valueTo) {
              query['realFoodCost[lte]'] = filters.valueTo;
            }
          }

          if (query.priceAfterDiscount) {
            const filters = query.priceAfterDiscount;
            delete query.priceAfterDiscount;
            if (filters.valueFrom) {
              query['priceAfterDiscount[gte]'] = filters.valueFrom;
            }
            if (filters.valueTo) {
              query['priceAfterDiscount[lte]'] = filters.valueTo;
            }
          }

          if (
            query?.priceFromMoneyBox?.valueFrom ||
            query?.priceFromMoneyBox?.valueTo
          ) {
            if (query.priceFromMoneyBox.valueFrom) {
              query['priceFromMoneyBox[gte]'] =
                query.priceFromMoneyBox.valueFrom;
            }
            if (query.priceFromMoneyBox.valueTo) {
              query['priceFromMoneyBox[lte]'] = query.priceFromMoneyBox.valueTo;
            }
          }

          if (query?.income?.valueFrom || query?.income?.valueTo) {
            if (query.income.valueFrom) {
              query['priceFromMoneyBox[gte]'] = query.income.valueFrom;
            }
            if (query.income.valueTo) {
              query['priceFromMoneyBox[lte]'] = query.income.valueTo;
            }
          }
          return query;
        }}
      />
    </>
  );
};

export default EcommerceBagHistory;
